var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "modal-create-report",
        adaptive: true,
        width: "100%",
        height: "100%"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "fixed top-0 left-0 flex flex-col justify-between w-screen h-screen bg-slate-200",
          style: { zIndex: "1000" }
        },
        [
          _c("div", { attrs: { id: "container" } }, [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center flex-shrink-0 h-12 px-6 bg-pure-white"
              },
              [
                _c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between h-16 gap-6 px-6 border-b bg-pure-white border-slate-400",
                attrs: { id: "header" }
              },
              [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-1" },
                  [
                    _c("BlTextTitle4", {
                      attrs: { text: "Create a new report" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlIcon", {
                  attrs: { icon: "close", clickable: "" },
                  on: { clicked: _vm.onClose }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "relative flex overflow-hidden transition-all duration-500",
                style: {
                  width: "200vw",
                  transform:
                    _vm.step === 1 ? "translateX(0vw)" : "translateX(-100vw) "
                },
                attrs: { id: "body" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex w-screen",
                    attrs: { id: "report-step-1" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col items-center w-full overflow-y-auto",
                        style: { height: "calc(100vh - 12rem)" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-4 py-6 max-w-152" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col justify-center w-full px-10"
                              },
                              [
                                _c("BlTextSubtitle1", {
                                  attrs: { text: "Select a template" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  attrs: {
                                    text:
                                      "Choose how you'd like to start your report. Don't worry—you can always make changes or add content as you go."
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.templateTypeOptions, function(template) {
                              return _c(
                                "div",
                                {
                                  key: template.value,
                                  staticClass:
                                    "flex flex-col items-center justify-center w-full gap-1 px-5 py-5 text-center transition-all duration-300 border rounded-lg cursor-pointer bg-pure-white",
                                  class: {
                                    "border-light-purple":
                                      _vm.templateTypeInput === template.value,
                                    "border-slate-400":
                                      _vm.templateTypeInput !== template.value
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.templateTypeInput = template.value
                                    }
                                  }
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    class: {
                                      "text-light-purple":
                                        _vm.templateTypeInput ===
                                        template.value,
                                      "text-slate-700":
                                        _vm.templateTypeInput !== template.value
                                    },
                                    attrs: { text: template.title }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody3", {
                                    staticClass: "whitespace-pre-line",
                                    attrs: { text: template.description }
                                  })
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col items-center flex-shrink-0 overflow-y-auto w-152 bg-slate-300",
                        style: { height: "calc(100vh - 12rem)" }
                      },
                      [
                        _vm.templateTypeInput
                          ? _c(
                              "div",
                              { staticClass: "py-8 w-132" },
                              [
                                _c("ReportTemplateExample", {
                                  attrs: { template: _vm.templateTypeInput }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex w-screen",
                    attrs: { id: "report-step-2" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col items-center w-full overflow-y-auto",
                        style: { height: "calc(100vh - 12rem)" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-4 py-6 max-w-152" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col justify-center w-full px-10"
                              },
                              [
                                _c("BlTextSubtitle1", {
                                  attrs: {
                                    text: "Modify the selected template"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.templateTypeInput
                                  ? _c(
                                      "div",
                                      [
                                        _c("BlTextBody2", {
                                          attrs: { text: "You have selected " }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "font-bold",
                                          attrs: {
                                            text: _vm.templateTypeOptions.find(
                                              function(i) {
                                                return (
                                                  i.value ===
                                                  _vm.templateTypeInput
                                                )
                                              }
                                            ).title
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: {
                                            text:
                                              "template for your report. Set the settings below to start building your report."
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-6 px-10 py-10 border bg-pure-white border-slate-400 rounded-3xl",
                                attrs: { id: "general-input" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-1" },
                                  [
                                    _c("BlTextSubtitle1", {
                                      attrs: { text: "Set report name" }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "Set the name for your report, and it will be shown as the report's title."
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlInputText", {
                                      attrs: { input: _vm.nameInput },
                                      on: { changed: _vm.inputHandler }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.templateTypeInput !==
                                "selected_curricula_or_target_types"
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-col gap-1" },
                                      [
                                        _c("BlTextSubtitle1", {
                                          attrs: { text: "Set date range" }
                                        }),
                                        _vm._v(" "),
                                        _vm.templateTypeInput === "blank"
                                          ? _c("BlTextBody2", {
                                              attrs: {
                                                text:
                                                  "Set the date range for this report, and we'll recommend targets that have made progress during this period, which you can view in the graph section later."
                                              }
                                            })
                                          : _c("BlTextBody2", {
                                              attrs: {
                                                text:
                                                  "Define the date range to automatically pull in graphs from all targets that have made progress within this timeframe. Targets that have not made any progress during this period will not be included."
                                              }
                                            }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-4"
                                          },
                                          [
                                            _c("BlInputDate", {
                                              attrs: {
                                                input: _vm.startDateInput
                                              },
                                              on: { changed: _vm.inputHandler }
                                            }),
                                            _vm._v(" "),
                                            _c("BlInputDate", {
                                              attrs: {
                                                input: _vm.endDateInput
                                              },
                                              on: { changed: _vm.inputHandler }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.templateTypeInput ===
                            "selected_curricula_or_target_types"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col gap-6 px-10 py-10 border bg-pure-white border-slate-400 rounded-3xl",
                                    attrs: { id: "selection-input" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-col gap-1" },
                                      [
                                        _c("BlTextSubtitle1", {
                                          attrs: {
                                            text:
                                              "Selection type: curricula or data collection methods"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: {
                                            text:
                                              "Choose whether to include targets based on specific curricula or data collection methods. This selection will define which target graphs are included in your report."
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "grid grid-cols-2 gap-4"
                                          },
                                          _vm._l(
                                            _vm.selectionTypeOptions,
                                            function(selection) {
                                              return _c(
                                                "div",
                                                {
                                                  key: selection.value,
                                                  staticClass:
                                                    "flex items-center justify-center text-center border rounded cursor-pointer h-15",
                                                  class: [
                                                    _vm.selectionTypeInput ===
                                                    selection.value
                                                      ? "border-light-purple"
                                                      : "border-slate-400"
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      _vm.selectionTypeInput =
                                                        selection.value
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("BlTextSubtitle3", {
                                                    class: [
                                                      _vm.selectionTypeInput ===
                                                      selection.value
                                                        ? "text-light-purple"
                                                        : "text-slate-700"
                                                    ],
                                                    attrs: {
                                                      text: selection.label
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.selectionTypeInput === "by_curricula"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex flex-col gap-1"
                                          },
                                          [
                                            _c("BlTextSubtitle1", {
                                              attrs: {
                                                text: "Select curricula"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              attrs: {
                                                text:
                                                  "Choose the curricula that will determine which target graphs are included in your report."
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-col gap-2 px-2 py-2 rounded bg-slate-300"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center justify-between"
                                                  },
                                                  [
                                                    _c("BlTextBody2", {
                                                      attrs: {
                                                        text:
                                                          _vm.curriculumIdsInput
                                                            .length +
                                                          " curricula selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("BlInputButton", {
                                                      attrs: {
                                                        type: "outlined",
                                                        dense: "",
                                                        label: "Add curricula"
                                                      },
                                                      on: {
                                                        clicked:
                                                          _vm.openCurriculum
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.curriculumIdsInput.length
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "grid grid-cols-2 gap-2"
                                                      },
                                                      _vm._l(
                                                        _vm.curriculumIdsInput,
                                                        function(id) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: id,
                                                              staticClass:
                                                                "flex items-center justify-between h-10 px-2 rounded bg-pure-white"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex items-center gap-2 truncate"
                                                                },
                                                                [
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "flex-shrink-0 w-4 h-4 rounded-full",
                                                                    style: {
                                                                      backgroundColor:
                                                                        _vm.curriculumOptions.find(
                                                                          function(
                                                                            i
                                                                          ) {
                                                                            return (
                                                                              i.curriculum_id ===
                                                                              id
                                                                            )
                                                                          }
                                                                        )
                                                                          .curriculum_color ||
                                                                        "grey"
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "BlTextBody2",
                                                                    {
                                                                      staticClass:
                                                                        "truncate",
                                                                      attrs: {
                                                                        text: _vm.curriculumOptions.find(
                                                                          function(
                                                                            i
                                                                          ) {
                                                                            return (
                                                                              i.curriculum_id ===
                                                                              id
                                                                            )
                                                                          }
                                                                        )
                                                                          .curriculum_name
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c("BlIcon", {
                                                                attrs: {
                                                                  icon: "close",
                                                                  clickable: ""
                                                                },
                                                                on: {
                                                                  clicked: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onRemoveCurriculum(
                                                                      id
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectionTypeInput ===
                                    "by_data_collection_methods"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex flex-col gap-1"
                                          },
                                          [
                                            _c("BlTextSubtitle1", {
                                              attrs: {
                                                text:
                                                  "Select data collection methods"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              attrs: {
                                                text:
                                                  "Choose the data collection methods that will determine which target graphs are included in your report."
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.filteredTypeOptions,
                                              function(type) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: type.value,
                                                    staticClass:
                                                      "flex items-center h-10 gap-2 px-4 border rounded border-grey-200"
                                                  },
                                                  [
                                                    _c("BlInputCheck", {
                                                      attrs: {
                                                        checked: _vm.typesInput.includes(
                                                          type.value
                                                        )
                                                      },
                                                      on: {
                                                        changed: function(
                                                          $event
                                                        ) {
                                                          return _vm.onCheckType(
                                                            type.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("BlTextBody2", {
                                                      attrs: {
                                                        text: type.label
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.templateTypeInput === "progress_highlights" ||
                            _vm.templateTypeInput ===
                              "selected_curricula_or_target_types"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col gap-1 px-10 py-10 border bg-pure-white border-slate-400 rounded-3xl",
                                    attrs: { id: "status-input" }
                                  },
                                  [
                                    _c("BlTextSubtitle1", {
                                      attrs: {
                                        text: "Filter targets by current status"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "Choose which targets to hide in your report based on their current status. If you uncheck a status in this step, you can always include those targets again when building your report later."
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.statusOptions, function(status) {
                                      return _c(
                                        "div",
                                        {
                                          key: status.value,
                                          staticClass:
                                            "flex items-center h-10 gap-2 px-4 border rounded border-grey-200"
                                        },
                                        [
                                          _c("BlInputCheck", {
                                            attrs: {
                                              checked: _vm.statusesInput.includes(
                                                status.value
                                              )
                                            },
                                            on: {
                                              changed: function($event) {
                                                return _vm.onCheckStatus(
                                                  status.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlChip", {
                                            attrs: {
                                              chip:
                                                status.value === "in_progress"
                                                  ? "in_acquisition"
                                                  : status.value
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.templateTypeInput ===
                            "selected_curricula_or_target_types"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col gap-1 px-10 py-10 border bg-pure-white border-slate-400 rounded-3xl",
                                    attrs: { id: "limit-date-input" }
                                  },
                                  [
                                    _c("BlTextSubtitle1", {
                                      attrs: {
                                        text: "Limit date range for graphs"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "Limit the date range for your graphs to highlight progress within a specific timeframe. This ensures that only relevant progress is shown, making the graphs more legible."
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-4"
                                      },
                                      [
                                        _c("BlInputDate", {
                                          attrs: { input: _vm.startDateInput },
                                          on: { changed: _vm.inputHandler }
                                        }),
                                        _vm._v(" "),
                                        _c("BlInputDate", {
                                          attrs: { input: _vm.endDateInput },
                                          on: { changed: _vm.inputHandler }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.templateTypeInput !== "blank"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col gap-1 px-10 py-10 border bg-pure-white border-slate-400 rounded-3xl",
                                    attrs: { id: "includes-description-input" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pl-2 pr-4",
                                            style: { transform: "scale(1.375)" }
                                          },
                                          [
                                            _c("BlInputToggle", {
                                              attrs: {
                                                checked:
                                                  _vm.includeTargetDescriptionInput
                                              },
                                              on: {
                                                changed: function($event) {
                                                  _vm.includeTargetDescriptionInput = !_vm.includeTargetDescriptionInput
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("BlTextSubtitle1", {
                                          attrs: {
                                            text:
                                              "Include target description on the graph"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "By turning on this option, we will include each target's description directly on the graphs in your report to provide additional context. You can choose to remove these descriptions later when building your report."
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.templateTypeInput !== "blank"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col gap-1 px-10 py-10 border bg-pure-white border-slate-400 rounded-3xl",
                                    attrs: { id: "narative-language-input" }
                                  },
                                  [
                                    _c("BlTextSubtitle1", {
                                      attrs: {
                                        text: "Select narrative language"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "Choose the language for the automatically generated narratives in your report, available in English or Indonesian. This setting does not affect the target descriptions, as they remain in the language they were originally written."
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center h-10 gap-2 px-4 border rounded border-grey-200"
                                      },
                                      [
                                        _c("BlInputRadio", {
                                          attrs: {
                                            name: "narative_language",
                                            checked:
                                              _vm.narativeLanguageInput === "en"
                                          },
                                          on: {
                                            changed: function($event) {
                                              _vm.narativeLanguageInput = "en"
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: { text: "English" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center h-10 gap-2 px-4 border rounded border-grey-200"
                                      },
                                      [
                                        _c("BlInputRadio", {
                                          attrs: {
                                            name: "narative_language",
                                            checked:
                                              _vm.narativeLanguageInput === "id"
                                          },
                                          on: {
                                            changed: function($event) {
                                              _vm.narativeLanguageInput = "id"
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: { text: "Indonesian" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.templateTypeInput !== "blank"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-col flex-shrink-0 overflow-y-auto border-l w-116 bg-pure-white border-slate-400",
                            style: { height: "calc(100vh - 12rem)" },
                            attrs: { id: "targets-preview" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "sticky top-0 z-10 flex flex-col gap-1 px-6 py-6 border-b bg-pure-white border-slate-400"
                              },
                              [
                                _c("BlTextSubtitle1", {
                                  attrs: {
                                    text: "Targets to be added to the report"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("BlTextBody2", {
                                      attrs: { text: "Graph(s) from " }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      staticClass: "font-bold",
                                      attrs: {
                                        text: _vm.targetsPreview.length + " "
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "target(s) will be included in your report based on the settings."
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.fetchTargetLoading
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "grid h-full place-items-center"
                                  },
                                  [_c("div", { staticClass: "blum-loader" })]
                                )
                              : !_vm.targetsPreview.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "grid h-full px-16 text-center place-items-center"
                                  },
                                  [
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "No targets are available. Set the date range to see which targets will be included in your report."
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm._l(_vm.targetsPreview, function(
                                      target
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: target.id,
                                          staticClass:
                                            "relative flex border-b h-28 border-slate-400"
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "h-full w-1.5",
                                            style: {
                                              backgroundColor:
                                                target.curriculum_color
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-col gap-1 px-6 py-4 w-112"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex" },
                                                [
                                                  _c("BlChip", {
                                                    attrs: {
                                                      chip:
                                                        target.status ===
                                                        "in_progress"
                                                          ? "in_acquisition"
                                                          : target.status
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                staticClass: "truncate",
                                                attrs: {
                                                  text: target.curriculum_name
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextSubtitle3", {
                                                staticClass: "truncate",
                                                attrs: { text: target.name }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid px-16 text-center h-28 place-items-center"
                                      },
                                      [
                                        _c("BlTextBody2", {
                                          attrs: { text: "End of list." }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sticky bottom-0 z-20 flex items-center justify-between h-20 px-6 border-t border-slate-500 bg-pure-white",
              attrs: { id: "footer" }
            },
            [
              _c("div", {
                staticClass:
                  "absolute left-0 z-10 w-screen h-10 border-b white-overlay bottom-full border-slate-500"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col gap-2" }, [
                _c("div", { staticClass: "flex items-center gap-1" }, [
                  _c("div", {
                    staticClass:
                      "flex-shrink-0 w-20 h-1 rounded bg-light-purple"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "flex-shrink-0 w-20 h-1 rounded",
                    class: [_vm.step === 2 ? "bg-light-purple" : "bg-slate-400"]
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex gap-1" }, [
                  (!_vm.templateTypeInput && _vm.step === 1) || _vm.step === 2
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "relative flex items-center justify-center w-5 h-5 border rounded-full border-slate-600"
                        },
                        [_c("BlTextSubtitle4", { attrs: { text: _vm.step } })],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "relative flex items-center justify-center w-5 h-5 border rounded-full border-success-400"
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "w-6 h-6",
                            attrs: { icon: "check", color: "success-4" }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex h-5" },
                    [
                      _c("BlTextSubtitle3", {
                        attrs: {
                          text:
                            _vm.step === 1
                              ? "Select a template"
                              : "Modify the selected template"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-4" },
                [
                  _vm.step === 1
                    ? _c("BlInputButton", {
                        staticClass: "flex-shrink-0",
                        attrs: {
                          type: "outlined",
                          disabled: !_vm.templateTypeInput,
                          label: "Next: Modify selected template"
                        },
                        on: {
                          clicked: function($event) {
                            _vm.step = 2
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 2
                    ? _c("BlInputButton", {
                        staticClass: "flex-shrink-0",
                        attrs: { type: "outlined", label: "Back" },
                        on: {
                          clicked: function($event) {
                            _vm.step = 1
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 2
                    ? _c("BlInputButton", {
                        staticClass: "flex flex-shrink-0 truncate max-w-80",
                        attrs: {
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.submitLoading,
                          label:
                            _vm.templateTypeInput === "blank"
                              ? "Generate report"
                              : "Generate report with " +
                                _vm.targetsPreview.length +
                                " target(s)"
                        },
                        on: { clicked: _vm.onSubmit }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.curriculumOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Select curricula",
                label: "Save",
                description:
                  "We'll include all targets from the selected curricula that this client has."
              },
              on: {
                "backdrop-close": function($event) {
                  return _vm.closeCurriculum({ save: false })
                },
                "backdrop-action": function($event) {
                  return _vm.closeCurriculum({ save: true })
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "px-8 overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 16rem)" }
                },
                _vm._l(_vm.curriculumOptions, function(curriculum) {
                  return _c(
                    "div",
                    {
                      key: curriculum.curriculum_id,
                      staticClass:
                        "flex items-center justify-between h-12 gap-2 px-4 border-b w-140 border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-2 truncate" },
                        [
                          _c("BlInputCheck", {
                            attrs: {
                              checked: _vm.curriculumIdsModal.includes(
                                curriculum.curriculum_id
                              )
                            },
                            on: {
                              changed: function($event) {
                                return _vm.onCheckCurriculum(
                                  curriculum.curriculum_id
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "truncate",
                            attrs: { text: curriculum.curriculum_name }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-shrink-0" },
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text: curriculum.total_targets + " target(s)"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "absolute z-10 left-8 -bottom-12" },
                [
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        _vm.curriculumIdsModal.length + " curricula selected"
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b17234d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b17234d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/report/NewReportModal.vue
// module id = null
// module chunks = 